/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_View_Diet_EatenInputs */

const en_portal_view_diet_eaten = /** @type {(inputs: Portal_View_Diet_EatenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eaten`)
};

const pl_portal_view_diet_eaten = /** @type {(inputs: Portal_View_Diet_EatenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zjedzone`)
};

/**
* | output |
* | --- |
* | "Eaten" |
*
* @param {Portal_View_Diet_EatenInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_view_diet_eaten = /** @type {((inputs?: Portal_View_Diet_EatenInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_View_Diet_EatenInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_view_diet_eaten(inputs)
	return en_portal_view_diet_eaten(inputs)
});